import { ActionHandler } from 'action-handler';

const STATE_PROP = 'searchInput';

export default new ActionHandler({
  name: 'set_search_input',
  stateProp: STATE_PROP,
  defaultState: {
    [STATE_PROP]: {
      text: '',
      developerName: '',
      developerProfileId: undefined,
      userSetInput: false,
      type: undefined
    }
  },
  handler({ text, developerName, developerProfileId, userSetInput, type }) {
    return {
      text,
      developerName,
      developerProfileId,
      userSetInput,
      type
    };
  },
  reduce(
    state,
    { text, developerName, developerProfileId, userSetInput, type }
  ) {
    return {
      [STATE_PROP]: {
        text,
        developerName,
        developerProfileId,
        userSetInput,
        type
      }
    };
  }
});
